export { StudentValidateEmailPage } from "./StudentValidateEmailPage"
export type { StudentValidateEmailNotice, StudentValidateEmailPageProps } from "./StudentValidateEmailPage"
